import { useParams } from "react-router-dom";
import EditForm from "../components/edit/EditForm";
import NavBar from "../components/navbar/NavBar";
import { useGetTaskQuery } from "../features/api/apiSlice";

const Edit = () => {
  const { id } = useParams();
  const { data: task, isError, isLoading, error } = useGetTaskQuery(id);

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <p>Loading...</p>;
  } else if (!isLoading && isError) {
    content = <p>{error?.data}</p>;
  } else if (!isLoading && !isError) {
    content = <EditForm task={task} />;
  }

  return (
    <>
      <NavBar />

      <div className="container relative">
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
            Create Task for Your Team
          </h1>

          <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
            {content}
          </div>
        </main>
      </div>
    </>
  );
};

export default Edit;
